import React, {useContext, useEffect, useState} from "react";
import Button from '@mui/material/Button';
import { TextField, Typography } from "@mui/material";
import { EventContext } from "./AdminEvents";
import MemberEventTravel from "./MemberEventTravel"
import { AppContext } from "../../App";
import { Tooltip } from "@mui/material";

export default function AdminCreateNewEvent(props){

  const { activeUser, setChangesMade } = useContext(AppContext)
  const { setOverviewMode } = useContext(EventContext)

  const [travelParty, setTravelParty] = useState(activeUser.bandMembers.map((member)=> {
    return ({
      passengerName: member.name,
      passengerBod: member.dob,
      passengerId: member.id, 
      passengerPhone: member.phone,
      passengerEmail: member.email,
      passengerRole: member.role,
      departRoute: "", 
      departDate: "", 
      returnRoute: "",
      returnDate: "",
      prefTime: "",
      groundTravel: "",
      accom: ""
    })
  }))

  const [newEventDetails, setNewEventDetails] = useState({
    eventID: "",
    eventName: "",
    bandName: activeUser.bandName,
    eventDate: "",
    performTime: "",
    performDuration: "",
    venueName: "",
    venueAddress: "",
    performFee: "",
    additionalFee: "",
    comments: "",
    payTerms: "",
    promoterEmail: "",
    travel: travelParty,
    contractClauses: activeUser.contractClauses,
    contractOpenPar: activeUser.contractOpen.openPar,
    bandContactPerson: activeUser.adminDetails.contactPerson,
    bandEmail: activeUser.adminDetails.email
  })  

  function generateEventID(){
    const randomId = (Math.random() + 1).toString(36).substring(7)   
    setNewEventDetails({
      ...newEventDetails,
      eventID: randomId
    })
  }

  const handleChange = (e) => {
    setNewEventDetails({
      ...newEventDetails,
      [e.target.name]: e.target.value
    })
  }

  async function createEvent(e){
    e.preventDefault()
    const newEvent = {...newEventDetails}
    const user = localStorage.getItem("user")

    await fetch(`https://the-paper-pusher.herokuapp.com/createEvent/${user}`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(newEvent)
    })
    .catch(error=>{
      window.alert(error)
      return
    })
    setChangesMade(prev => prev+1)
  }

  console.log(newEventDetails)

  return (
    <div className="create-new-event-main">
      <Button onClick={()=> setOverviewMode(true)}>Back</Button>
      
      <h3 className="section-title">
        Create New Event
      </h3>
      <div className="event-inputs">
        <div className="event-id"><p className="event-id-main">Event ID: {newEventDetails.eventID}</p><Button disabled={newEventDetails.eventID != ""} onClick={generateEventID}>generate</Button></div>
        <TextField name="performFee" sx={{marginBottom: 2}} label="Performance Fee" onChange={handleChange}/>
        <TextField name="additionalFee" sx={{marginBottom: 2}} label="Additional Fee(s)" onChange={handleChange}/>
        <TextField name="payTerms" sx={{marginBottom: 2}} label="Payment Terms" onChange={handleChange}/>
        <TextField name="promoterEmail" sx={{marginBottom: 2}} label="Promoter Email Address" onChange={handleChange}/>
        <TextField name="comments" sx={{marginBottom: 2}} label="Comments" onChange={handleChange}/>
      </div>

      <h5 className="admin-section-title">
        Travel and Accommodation
      </h5>
      <div className="accordian-container">
        {activeUser.bandMembers.map(member => {
          return (<MemberEventTravel 
                    name={member.name} 
                    dob={member.dob}
                    phone={member.phone}
                    email={member.email}
                    idNumber={member.id}
                    role={member.role}
                    travelParty={travelParty} 
                    setTravelParty={setTravelParty} 
                    setData={setNewEventDetails}/>)
        })}
        
      </div>
      <Button disabled={newEventDetails.eventID === ""} onClick={(e) => createEvent(e)}>Save</Button>
      {newEventDetails.eventID === "" ?
      <Typography sx={{color: 'red', fontSize: '0.7em'}}>*remember to generate an eventID</Typography>: 
      <div><Typography sx={{color: '#FF7C7C'}}>Save and send the following to the promoter:</Typography>
      <Typography sx={{fontSize: '1em', maxWidth: 400, margin: '1em Auto', padding: '0.5em', border: 'solid 1px black', borderRadius:'5px'}}>Thanks for booking {newEventDetails.bandName}! <br/>
      Please visit <a href="https://paper-pusher.netlify.app/promoter" target="_blank" >https://paper-pusher.netlify.app/promoter</a> and login
      with event ID {newEventDetails.eventID}</Typography></div>}
      
    </div>
  )
}